import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RequestService } from '../service/request.service';

@Injectable({
  providedIn: 'root',
})
export class PreviousOrderGuard implements CanActivate {
  constructor(
    private _requestService: RequestService,
    private _router: Router
  ) {}

  canActivate() {
    if (this._requestService.isLoggedIn()) {
      return true;
    } else {
      this._router.navigateByUrl(this._requestService.setUrl('login?guest=false'));
      return false;
    }
  }
}
